import styled from 'styled-components';
import { FormTitle } from '../styles';

export const StyledFormTitle = styled(FormTitle)`
  && {
    margin-bottom: 16px;
    ${props => `margin-top: ${props.marginTop};` || ""}
  }
`;
